import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import order from './modules/order';
import report from './modules/report';
import stock from './modules/stock';
import base from './modules/base';
import deposit from './modules/deposit';
/**
 * @description 给菜单数据补充上 path 字段
 * @description https://github.com/d2-projects/d2-admin/issues/209
 * @param {Array} menu 原始的菜单数据
 */

var menuAside = [];
export function loadMenuAside() {
  return _loadMenuAside.apply(this, arguments);
}

function _loadMenuAside() {
  _loadMenuAside = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            menuAside = [{
              path: '/index',
              title: '工作台首页',
              icon: 'home'
            }, order, report, stock, base, deposit];
            menuHeader = [];
            menuAside.map(function (item) {
              menuHeader.push({
                path: item.path,
                title: item.title,
                icon: item.icon
              });
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadMenuAside.apply(this, arguments);
}

export { menuAside };
export function clearMenu() {
  menuAside = [];
  menuHeader = [];
}
var menuHeader = [];
export { menuHeader };